import * as React from 'react';

import {useBookingMachine} from '../../hooks/useBookingMachine';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {BrandButton} from '../../lib/brand-button/brand-button';
import {EmptyState} from '@spaced-out/ui-design-system/lib/components/EmptyState';
import {generateTestId} from '@spaced-out/ui-design-system/lib/utils/qa';
import {TEST_ID} from '../../utils/testId';


export const UnavailableTimeSlot = ({
  isRescheduleFlow,
}: {
  isRescheduleFlow: boolean;
}) => {
  const {t} = useLabelTranslation();
  const {bookingActor} = useBookingMachine();

  const handleChooseDifferentTimeSlot = () => {
    if (isRescheduleFlow) {
      bookingActor.send({type: 'refetchAvailabilityForReschedule.go'});
    } else {
      bookingActor.send({type: 'refetchAvailability.go'});
    }
  };

  return (
    <EmptyState
      imageVariant="calendar"
      title={t('Unable_to_schedule_meeting', 'Unable to schedule meeting')}
      description={t(
        'The_time_slot_you_selected_is_no_longer_available_Please_choose_a_different_slot',
        'The time slot you selected is no longer available. Please choose a different slot',
      )}
    >
      <BrandButton
        onClick={handleChooseDifferentTimeSlot}
        testId={generateTestId({
          base: TEST_ID.BOOKING_FLOW,
          slot: 'unavailable-time-slot-button',
          index: isRescheduleFlow ? 'reschedule' : 'booking',
        })}
      >
        {t('Choose_a_different_time_slot', 'Choose a different time slot')}
      </BrandButton>
    </EmptyState>
  );
};
